import { render, staticRenderFns } from "./cModalViewDetail.vue?vue&type=template&id=595fcaf0&scoped=true"
import script from "./cModalViewDetail.vue?vue&type=script&lang=js"
export * from "./cModalViewDetail.vue?vue&type=script&lang=js"
import style0 from "./cModalViewDetail.vue?vue&type=style&index=0&id=595fcaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595fcaf0",
  null
  
)

export default component.exports